<template>
    <div class="cont">
        <div class="contenu">
            <div class="header">
                <div class="header-content">
                    <div class="title-wrapper">
                        <span class="title-badge">Documents de mon Courtier</span>
                    </div>
                </div>
                <button
                    @click="appQuitter"
                    class="close-btn"
                    title="Fermer"
                >
                    <i class="fas fa-times"></i>
                </button>
            </div>
            
            <div v-if="isLoading" class="content-wrapper">
                <div class="loader-container">
                    <div class="spinner"></div>
                    <p>Chargement des documents...</p>
                </div>
            </div>
            
            <div v-else>               
                <ListeDocument  
                    :listeDocument ="listeDocument" 
                    :titreFolder="''"
                    :isDocCom="true"  
                    >
                </ListeDocument>                                             
            </div>
        </div>
        
        <transition name = "fade">
            <div v-if="ouvrirWebWiewer">
                <ModalEspaceClient
                        :fichierUrl="fichierUrl"    
                        >
                </ModalEspaceClient>
            </div>
        </transition>
    </div>
</template>

<script>
    import api from '@/api'
    import ListeDocument from '@/views/piecesJustificatives/ListeDocument.vue'
    import ModalEspaceClient from '../../components/ModalEspaceClient.vue' 
    export default {
        name:'DocumentsCommerciauxEspace',
        components:{
            ListeDocument,
            ModalEspaceClient
        },
        data(){                
            return{
                listeDocument:null,
                fichierUrl:"",
                ouvrirWebWiewer:false,
                isLoading:true                       
            }
        },
        created(){
            //API
            this.isLoading = true
            api.documentsCommerciauxAfficher(this.$route.params.dossierId)
            .then( (response) => {
                this.listeDocument = response.data
                this.isLoading = false    
            }),
            //EVENT
            //évenement reçu par le composant SimpleUpload
            this.$root.$on('ouvrirWebViewer',(fichierUrl,afficher)=>{
                this.fichierUrl = fichierUrl
                if(afficher == true){
                    this.ouvrirWebWiewer=true
                }        
            }),
            //
            this.$root.$on('fermerWebViewer',()=>{
                this.fichierUrl = ""
                this.ouvrirWebWiewer=false
            })
           
        },
        methods:{   
            //méthode appeler par la buton pour fermer l'application
             appQuitter(){
                window.location.href = '/'
                this.btnReturn.click()
            }
            
        }
    }
</script>


<style lang="scss" scoped>
 @import "../../assets/scss/colors";

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 2px solid #0b357f;
        gap: 15px;
        margin-bottom: 15px;
        border-radius: 6px 6px 0 6px;

        .close-btn {
            color: #0b357f;
        }
    }

    .header-content {
        flex: 1;
        display: flex;
        align-items: center;
    }

    .title-wrapper {
        display: flex;
        align-items: center;
        gap: 15px;
        width: 100%;
    }

    .title-badge {
        display: inline-block;
        background-color: #0b357f;
        color: white;
        padding: 13px 20px;
        border-radius: 6px 6px 0 0;
        font-weight: 600;
        font-size: 14px;
        letter-spacing: 0.5px;
        white-space: nowrap;
        text-transform: uppercase;
    }

    .close-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border: none;
        background-color: transparent;
        color: #0b357f;
        font-size: 24px;
        cursor: pointer;
        transition: all 0.2s ease;
        border-radius: 6px;
        flex-shrink: 0;
        padding: 0;
        
        &:hover {
            background-color: rgba(11, 53, 127, 0.1);
            transform: rotate(90deg);
        }
        
        &:active {
            background-color: rgba(11, 53, 127, 0.2);
        }
    }

    .cont {
        overflow-y: scroll;
        overflow-x: unset;
        height: 100% !important;
        background-color: #f8f9fb;
        padding: 15px;

        &.cadre-content-principal {
        }
    }

    .contenu {
        overflow-y: auto !important;
        overflow-x: hidden !important;
        padding: 15px;
        background-color: #fff;
        scroll-behavior: smooth;
        box-shadow: 0 0 5px 5px #f4f5f6;
        border-radius: 6px;
    }

    .cadre-folder {
        max-width: 400px;
        margin: left;
    }

    .menu-brique a {
        border-radius: 0;
    }

    .cadre-pied {
        margin-left: auto;
    }
    
    @media (max-width: 350px) {
     .piece-conteneur{
        flex-direction: column;
     }    
    }

    @media (min-width: 351px) {
     .piece-conteneur{
        flex-direction: row;
     }
    }

    .modalWebWiew {
        position: absolute;
        top: 15px;
        width: 100%;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: all 1s ease;
    }

    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
    }

    .content-wrapper {
        min-height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .loader-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 20px;
        padding: 40px 20px;
    }

    .spinner {
        width: 50px;
        height: 50px;
        border: 4px solid rgba(11, 53, 127, 0.2);
        border-top-color: #0b357f;
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
    }

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }

    .loader-container p {
        color: #0b357f;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0.3px;
    }
</style>